// react-bootstrap
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

// project-imports
import useConfig from 'hooks/useConfig';
import branding from 'branding.json';

const APP_VERSION = import.meta.env.SX_VITE_APP_VERSION ?? '';

// ==============================|| MAIN LAYOUT - FOOTER ||============================== //
export default function Footer() {
  const { container } = useConfig();

  return (
    <footer className="pc-footer">
      <div className={`footer-wrapper ${container === false ? 'container-fluid' : 'container'}`}>
        <Row className="justify-content-center justify-content-md-between">
          {/* Footer Text */}
          <Col xs="auto" className="my-1">
            <p className="m-0">
              Crafted By{' '}
              <span className="text-primary">{branding.brandName}</span> ♥
            </p>
          </Col>

          {/* Version */}
          {APP_VERSION && (
            <Col xs="auto" className="my-1">
              <p className="m-0 text-muted">
                Versión {APP_VERSION}
              </p>
            </Col>
          )}
        </Row>
      </div>
    </footer>
  );
}
